export function dynamicGap() {
    const articlewpBlockGroups = document.querySelectorAll(
        ".articles-module > .wp-block-group"
    );
    const articlewpBlockSwiper = document.querySelectorAll(
        ".articles-module > .swiper .swiper-wrapper"
    );

    if (articlewpBlockGroups) {
        articlewpBlockGroups.forEach((group) => {

            const gapVertical = group.getAttribute("data-gap-vertical");

            if (gapVertical) {
                const remValue = `${parseInt(gapVertical) / 10}rem`;
                group.style.setProperty("--dynamic-gap", remValue);
            }
        });
    }

    if (articlewpBlockSwiper) {
        articlewpBlockSwiper.forEach((wrapper) => {
            const gapVertical = wrapper.getAttribute("data-gap-vertical");
            const dataColumns = wrapper.getAttribute("data-columns");

            if (dataColumns === 1) {
                return
            }

            if (gapVertical) {
                const remValue = `${parseInt(gapVertical) / 10}rem`;
                wrapper.style.setProperty("--dynamic-gap", remValue);
            }
        });
    }
}
